export class ColorBoundaryContainer extends Array {
    constructor(...items) {
        super(...items);
    }
    static transform(arr) {
        return new ColorBoundaryContainer(...arr);
    }
    get_matching(name) {
        return ColorBoundaryContainer.transform(this.filter(b => b.label === name));
    }
    turn_on(name) {
        this.get_matching(name).forEach(b => b.visible = true);
    }
    turn_off(name) {
        this.get_matching(name).forEach(b => b.visible = false);
    }
    toggle(name) {
        this.get_matching(name).forEach(b => b.visible = !b.visible);
    }
    all_on() {
        this.forEach(b => b.visible = true);
    }
    all_off() {
        this.forEach(b => b.visible = false);
    }
    invert_on(name) {
        let target_is_on = this.get_matching(name).every(b => b.visible);
        let all_others_off = this.filter(b => b.label !== name).every(b => !b.visible);
        if (target_is_on && all_others_off) {
            this.forEach(b => b.visible = true);
            return;
        }
        this.all_off();
        this.turn_on(name);
    }
}
